export default "__VITE_ASSET__DeQfeeLV__"